import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { seoTemplatePageDetailLoad } from "store/models/seoTemplatePage";
import { DetailLoadComponent } from 'components/common';


const SeoTemplatePageValue = (props) => {
  return (
    <DetailLoadComponent
      apiLoad={seoTemplatePageDetailLoad}
      {...props}
      getDetailUrl={(id, item) => props.model.urls.detail(item?.site_id, id)}
      render={({ id, item, linkPath }) => {
        const value = item?.tpl_path || id;

        return (
          <Fragment>
            {props.asLink && linkPath ?
              <Link to={linkPath}>{value}</Link> :
              <span>{value}</span>}
          </Fragment>
        );
      }}
    />
  );
};

const mapState = state => ({
  router: state.router,
  authToken: state.auth.token,
  model: state.seoTemplatePage,
});

export default connect(mapState)(SeoTemplatePageValue);
